import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import "./Graph.css";

const data = [
  { date: "01 May-25", value: 2.7 },
  { date: "01 Jun-25", value: 5.3 },
  { date: "01 Jul-25", value: 8.0 },
  { date: "01 Aug-25", value: 10.6 },
  { date: "01 Sep-25", value: 13.3 },
  { date: "01 Oct-25", value: 16.0 },
  { date: "01 Nov-25", value: 18.6 },
  { date: "01 Dec-25", value: 21.3 },
  { date: "01 Jan-26", value: 23.9 },
  { date: "01 Feb-26", value: 26.6 },
  { date: "01 Mar-26", value: 29.3 },
  { date: "01 Apr-26", value: 32.0 },
  { date: "01 May-26", value: 96.0 },
  { date: "01 Nov-26", value: 160.0 },

];

const Graph = () => {
  return (
    <div className="graph-container">
      <div className="graph-wrapper">
        <div className="graph-title">Cumulative Unlock (LFCoin)</div>
        <ResponsiveContainer width="100%" height={400}>
          <BarChart
            data={data}
            margin={{ top: 40, right: 30, left: 20, bottom: 50 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis className="toplabel-list"
              dataKey="date"
              angle={-30}
              textAnchor="end"
              tick={{ fill: "#800080" }}
              fontWeight="bold"
              interval={0} // Ensure all ticks are displayed
            />
            <YAxis tick={{ fill: "#800080" }} fontWeight="bold" />
            <Tooltip formatter={(value) => `${value} M`} fontWeight="bold" />
            <Bar dataKey="value" fill="#800080">
              <LabelList className="toplabel-list"
                dataKey="value"
                position="top"
                fontWeight="bold"
                fill="black"
                formatter={(value) => `${value} M`} // Format the label to include "M"
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default Graph;
